
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useState } from "react";

interface HeroProps {
  onSearch?: (query: string) => void;
  title?: string;
  subtitle?: string;
  buttonText?: string;
  buttonLink?: string;
}

export const Hero = ({ 
  onSearch, 
  title = "Find Top Contractors",
  subtitle = "Connect with high quality home service professionals in our area",
  buttonText,
  buttonLink
}: HeroProps) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onSearch) {
      onSearch(searchQuery);
    }
  };

  return (
    <div className="relative py-16 md:py-24 px-4 md:px-6 bg-gradient-to-b from-[#174996]/10 to-transparent">
      <div className="max-w-4xl mx-auto text-center space-y-6">
        <h1 className="text-4xl md:text-6xl font-bold mb-4 leading-tight bg-clip-text text-transparent bg-gradient-to-r from-[#174996] to-blue-600">
          {title.includes(" in ") ? (
            <>
              <span className="block mb-2">{title.split(" in ")[0]}</span>
              <span className="block">in {title.split(" in ")[1]}</span>
            </>
          ) : (
            <span className="block">{title}</span>
          )}
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
          {subtitle}
        </p>
        
        {onSearch ? (
          <form onSubmit={handleSubmit} className="relative max-w-xl mx-auto">
            <div className="flex flex-col sm:flex-row gap-2">
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
                <Input
                  placeholder="Search contractors..."
                  className="pl-10 h-12"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <Button type="submit" size="lg" className="bg-[#174996] hover:bg-[#174996]/90 w-full sm:w-auto">
                Search
              </Button>
            </div>
          </form>
        ) : buttonText && buttonLink ? (
          <div className="flex justify-center">
            <Button 
              size="lg" 
              className="bg-[#174996] hover:bg-[#174996]/90"
              onClick={() => {
                const element = document.querySelector(buttonLink);
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              {buttonText}
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};
